// extracted by mini-css-extract-plugin
export var lightMode = "_l-0";